import { Button } from '@/components/common/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogContentWrapper,
  DialogHeader,
  DialogHeaderWrapper,
  DialogScrollArea,
  DialogTitle,
  DialogTrigger,
} from '@/components/common/dialog'
import { Separator } from '@/components/common/separator'
import { routes } from '@/config/routes'
import { cn } from '@/utils/cn'
import { useState } from 'react'
import { Link } from 'react-router'
import { PositionDetails } from '../sidePanel/positionDetails'
import { ProjectedEarnings } from '../sidePanel/projectedEarnings'
import type { TxPanelSharedProps } from '../txPanel/txPanel'
import { TxPanelContent } from '../txPanel/txPanelContent'

interface BottomPanelProps {
  className?: string
}

export const BottomPanel = ({
  vault,
  walletAddress,
  transactionsContext,
  tabValue,
  setTabValue,
  tabsConfig,
  positionValue,
  parsedAmount,
  totalPositionValue,
  isContainRewards,
  isContextError,
  isContextFetching,
  onRetryContext,
  className,
}: TxPanelSharedProps & BottomPanelProps) => {
  const { protocolVaultUrl } = vault
  const [widgetOpen, setWidgetOpen] = useState(false)

  return (
    <div className={cn('rounded-t-2xl border bg-surface', className)} data-location="bottom">
      <Dialog open={widgetOpen} onOpenChange={setWidgetOpen}>
        {!vault.isTransactional && (
          <div className="flex flex-wrap gap-1 pb-4 text-sm">
            <p>Transaction support coming soon.</p>
            <div className="flex flex-wrap gap-1 text-center">
              <Button variant="default" size="default" className="rounded-full underline" asChild>
                <Link to={routes.root}>Check out other opportunities</Link>
              </Button>
              {protocolVaultUrl && (
                <>
                  <p>or go</p>
                  <Button variant="default" size="default" className="rounded-full underline" asChild>
                    <a href={protocolVaultUrl} target="_blank" rel="noreferrer">
                      to the protocol app
                    </a>
                  </Button>
                </>
              )}
            </div>
          </div>
        )}
        <DialogTrigger asChild>
          <Button size="sm" className="w-full" disabled={!vault.isTransactional}>
            {positionValue === 0n ? 'Supply' : 'Manage'}
          </Button>
        </DialogTrigger>
        <DialogContent position="right" className="bg-page" onOpenAutoFocus={(e) => e.preventDefault()}>
          <DialogBody>
            <DialogHeaderWrapper className="md:pt-8">
              <DialogHeader>
                <DialogTitle>{positionValue === 0n ? 'Supply' : 'Manage position'}</DialogTitle>
              </DialogHeader>
              <Separator />
            </DialogHeaderWrapper>
            <DialogScrollArea>
              <DialogContentWrapper className="pt-4">
                <TxPanelContent
                  vault={vault}
                  transactionsContext={transactionsContext}
                  tabValue={tabValue}
                  setTabValue={setTabValue}
                  tabsConfig={tabsConfig}
                  isContextError={isContextError}
                  isContextFetching={isContextFetching}
                  onRetryContext={onRetryContext}
                />
                <PositionDetails
                  totalPositionValue={totalPositionValue}
                  vault={vault}
                  walletAddress={walletAddress}
                  onNavigate={() => setWidgetOpen(false)}
                />
                <ProjectedEarnings
                  vault={vault}
                  parsedAmount={parsedAmount}
                  positionValue={positionValue}
                  tabValue={tabValue}
                  isContainRewards={isContainRewards}
                />
              </DialogContentWrapper>
            </DialogScrollArea>
          </DialogBody>
        </DialogContent>
      </Dialog>
    </div>
  )
}
